module.exports = __webpack_public_path__ + "media/wood-duck-3.bfa6f1f6.mp3";